module.exports = "/assets/08c2e62e7d1f514259af92204bc9c284.ico";